import { ReactNode, useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface AboutCardProps {
	title: string;
	children: ReactNode;
	headerActions?: ReactNode;
	defaultOpen?: boolean;
	collapsible?: boolean;
}

/**
 * Left-rail "About this X" / "Client Card" card containing a list of EditableField rows.
 * Collapsible via header click (HubSpot pattern).
 */
export function AboutCard({ title, children, headerActions, defaultOpen = true, collapsible = true }: AboutCardProps) {
	const [open, setOpen] = useState(defaultOpen);
	return (
		<div className="rounded-lg border bg-card">
			<div className="flex items-center justify-between px-3 py-2 border-b">
				<button
					type="button"
					onClick={() => collapsible && setOpen((o) => !o)}
					className="flex items-center gap-1 text-sm font-semibold text-foreground"
				>
					{collapsible && (open
						? <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
						: <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />
					)}
					{title}
				</button>
				{headerActions}
			</div>
			{open && (
				<div className="space-y-2.5 px-3 py-3">{children}</div>
			)}
		</div>
	);
}
